//import packages from node modules
import React, {useEffect, useState, useRef, useCallback} from 'react'
import PropTypes from 'prop-types'
import {change} from 'redux-form'

//import utility functions

import { addCssClass, removeCssClass } from '../../../../utilities/function/common'

//import shared components

import Tooltip from '../../tooltip'

export const renderLabel = (label,value,placeholder=null) => {
  const show = (label && value) || (label && placeholder && label !== placeholder)
  if(show){
    return <span className={'of-textfield__label text-font-1-100'}>{label}</span>
  }
  return (<></>)
}

export const renderDescription = (description) => {
  if (description) {
    return (
        <div className={'of-textfield__description'}>
          <Tooltip className={'of-textfield__tooltip'} description={description}/>
        </div>
    )
  }
  return (<></>)
}

let TextField = (props) => {

  //variables

  const {className, placeholder, type, meta,initialValue,optional,label,externalLink,description,onFocusOut,input, rows, autoFocus} = props
  const { error , touched,dispatch,form } = meta || {}
  const [optionalPlaceholder,setOptionalPlaceholder] = useState(false)
  const fieldRef = useRef(null)
  const initFlag = useRef(false)
  const {name,onBlur,onFocus} = input || {}

  //functions
  const isError = () => {
    return error && touched
  }
  const getErrorMessage = () =>{
    return error
  }
  const renderOptionalPlaceholder = () => {
    if(optionalPlaceholder){
      if(optional && input && !input.value){
        return (
            <div onClick={()=>{
              setOptionalPlaceholder(false)
              if(fieldRef && fieldRef.current){
                fieldRef.current.focus()
              }
            }} className={'of-textfield__placeholder text-font-4-100'}><span>{placeholder}</span> <i>(Optional)</i></div>
        )
      }
    }

    return(<></>)
  }
  const renderExternalLink = () => {
    if(externalLink){
      return <a className={'of-textfield__link primary-font-1-100'} tabIndex={-1} href={externalLink.link} target={'_blank'}>{externalLink.label}</a>
    }
    return (<></>)
  }

  //callback
  const initCallback = useCallback(()=>{
    if(initFlag.current===false){

      //set placeholder
      if(input && input.value){
        setOptionalPlaceholder(false)
      }else{
        setOptionalPlaceholder(true)
      }

      //set initial value
      if(initialValue){
        dispatch(change(form,name,initialValue))
      }
      initFlag.current = true
    }
  },[input,initFlag,initialValue,dispatch,form,name])

  const [, updateState] = useState();
  const forceUpdate = useCallback(() => updateState({}), []);


  useEffect(()=>{
    initCallback()
  },[initCallback])


  //render

  if(type==="hidden"){
    return (<>
      <input {...input} type={type} className={`${className?' '+className:''}`} ref={fieldRef}
      />
      {isError()?<div className={'of-textfield__error status-font-2-100'}>{getErrorMessage()}</div>:<></>}
    </>)
  }

  return(
    <div className={`of-textfield${isError?' of-textfield--error':''}${externalLink?' of-textfield--withlink':''}`}>
      {renderLabel(label,input? input.value : fieldRef && fieldRef.current? fieldRef.current.value: false ,placeholder)}
      {renderExternalLink()}
      {renderDescription(description)}
      { !rows ? 
      <input {...input} type={type?type:'text'}
             className={`${isError()?'status-border-2-100':'lines-border-1-100'} of-textfield__input${className?' '+className:''}`}
             placeholder={optional? null :placeholder}
             rows={rows ? rows : '1'}
             onFocus={(e)=>{
               if(onFocus){
                 onFocus()
               }else{
                 forceUpdate()
               }
               removeCssClass(e.currentTarget,'lines-border-1-100')
               addCssClass(e.currentTarget,'primary-border-1-100')
             }}
             onBlur={(e)=>{
               removeCssClass(e.currentTarget,'primary-border-1-100')
               addCssClass(e.currentTarget,'lines-border-1-100')
               if(onBlur){
                 onBlur()
               }else{
                 forceUpdate()
               }

               if(optional){
                 setOptionalPlaceholder(true)
               }

               if (onFocusOut){
                onFocusOut(fieldRef)
               }
             }}
             ref={fieldRef}
      />
      :
      <textarea {...input} type={type?type:'text'}
      className={`${isError()?'status-border-2-100':'lines-border-1-100'} of-textfield__input${className?' '+className:''}`}
      placeholder={optional? null :placeholder}
      rows={rows ? rows : '1'}
      autoFocus={autoFocus ? autoFocus : false}
      onFocus={(e)=>{
        if(onFocus){
          onFocus()
        }else{
          forceUpdate()
        }
        removeCssClass(e.currentTarget,'lines-border-1-100')
        addCssClass(e.currentTarget,'primary-border-1-100')
      }}
      onBlur={(e)=>{
        removeCssClass(e.currentTarget,'primary-border-1-100')
        addCssClass(e.currentTarget,'lines-border-1-100')
        if(onBlur){
          onBlur()
        }else{
          forceUpdate()
        }

        if(optional){
          setOptionalPlaceholder(true)
        }

        if (onFocusOut){
         onFocusOut(fieldRef)
        }
      }}
      ref={fieldRef}
    />
      }
      {renderOptionalPlaceholder()}
      {isError()?<div className={'of-textfield__error status-font-2-100'}>{getErrorMessage()}</div>:<></>}
    </div>
  )
}

TextField.propTypes = {
  label: PropTypes.string,
  input: PropTypes.any,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  externalLink: PropTypes.object,
  type: PropTypes.string,
  meta: PropTypes.any,
  initialValue: PropTypes.any,
  optional: PropTypes.bool,
  description: PropTypes.string,
  onFocusOut: PropTypes.any
}

export default TextField